var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",staticClass:"fb-like",attrs:{"data-href":_vm.url,"data-layout":"button","data-action":"like","data-size":"small","data-show-faces":"false","data-share":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }